module.exports = __webpack_public_path__ + "img/journey.fdfe5f97.png";